import { useCallback, useEffect, useState } from 'react';
import { fetchTuotteenSaatavuus } from '@/services/kalenteriService';

export function useItemAvailability(itemId, month, year) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    if (!itemId) return;

    setLoading(true);
    setError(null);

    try {
      const res = await fetchTuotteenSaatavuus(itemId, month, year);
      setData(res.availability || []);
    }
    catch (e) {
      setError(e);
    }
    finally {
      setLoading(false);
    }
  }, [itemId, month, year]);

  useEffect(() => {
    if (!itemId) return;

    let ignore = false;

    (async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await fetchTuotteenSaatavuus(itemId, month, year);
        // TODO: pitää jossain vaiheessa ottaa koko data talteen, eri tuotetyyppejä jne
        if (!ignore) setData(res.availability || []);
      }
      catch (e) {
        if (!ignore) setError(e);
      }
      finally {
        if (!ignore) setLoading(false);
      }
    })();

    return () => {
      ignore = true;
    };
  }, [itemId, month, year]);

  return { data, loading, error, refetch };
};
